<template>
  <section :id="$style.homerun_info">
    <main-title
      :class="$style.title"
      :main_title="'HR情報'"
      :sub_title="'Home run Information'"
      :color="'#403f3f'"
      :align="'center'"
    ></main-title>

    <div :id="$style.table_field">
      <div :id="$style.select_column">
        <div :id="$style.button_area">
          <b-button
            :class="$style.button"
            pill
            variant="info"
            v-on:click="set_affiliated_team('giants')"
          >巨人</b-button>
          <b-button
            :class="$style.button"
            pill
            variant="info"
            v-on:click="set_affiliated_team('mlb')"
          >MLB</b-button>
        </div>
        <multiselect
          v-model="selected"
          :class="$style.select"
          :options="getyear"
          :selectLabel="''"
          :deselectLabel="''"
          :searchable="false"
        ></multiselect>
      </div>
      <div :class="$style.post">pはポストシーズンの略</div>

      <div :class="$style.tb">
        <table>
          <tr>
            <th>日米通算</th>
            <th>本年</th>
            <th>日付</th>
            <th>球場</th>
            <th>対戦相手</th>
            <th>対戦投手</th>
            <th v-if="affiliated_team==='giants'">球種</th>
            <th v-if="affiliated_team==='giants'">本種</th>
            <th v-if="affiliated_team==='giants'">方向</th>
            <th v-if="affiliated_team==='giants'">飛距離</th>
            <th v-if="affiliated_team==='giants'">カウント</th>
            <th>結果</th>
            <th v-if="affiliated_team==='mlb'">コメント</th>
          </tr>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.career }}</td>
            <td>{{ item.year }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.place }}</td>
            <td>{{ item.advrs }}</td>
            <td>{{ item.picher }}</td>
            <td v-if="affiliated_team==='giants'">{{ item.ball }}</td>
            <td v-if="affiliated_team==='giants'">{{ item.hrp }}</td>
            <td v-if="affiliated_team==='giants'">{{ item.direct }}</td>
            <td v-if="affiliated_team==='giants'">{{ item.carry }}</td>
            <td v-if="affiliated_team==='giants'">{{ item.count }}</td>
            <td>{{ item.result }}</td>
            <td v-if="affiliated_team==='mlb'">{{ item.comment }}</td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
// import { Component, Vue } from "vue-property-decorator";

import MainTitle from "@/components/atoms/MainTitle.vue";
import Multiselect from "vue-multiselect";

import GiantsJson from "../../../assets/json/homerun/giants.json";
import MlbJson from "../../../assets/json/homerun/mlb.json";

export default Vue.extend({
  // @Component({
  name: "HomerunInfoVisual",

  components: {
    MainTitle,
    Multiselect
  },

  data: function() {
    return {
      giantsjson: GiantsJson,
      mlbjson: MlbJson,
      affiliated_team: "giants",
      selected: "1993",
      giantsopt: [
        "1993",
        "1994",
        "1995",
        "1996",
        "1997",
        "1998",
        "1999",
        "2000",
        "2001",
        "2002"
      ],
      mlbopt: [
        "2003",
        "2003p",
        "2004",
        "2004p",
        "2005",
        "2005p",
        "2006",
        "2007",
        "2008",
        "2009",
        "2009p",
        "2010",
        "2011",
        "2012"
      ]
    };
  },

  computed: {
    getyear: function() {
      if (this.affiliated_team == "giants") {
        return this.giantsopt;
      } else {
        return this.mlbopt;
      }
    },

    items: function() {
      if (this.affiliated_team == "giants") {
        return this.giantsjson[this.selected];
      } else {
        return this.mlbjson[this.selected];
      }
    }
  },

  methods: {
    set_affiliated_team: function(affiliated_team) {
      // 巨人化かMLBを設定する
      this.affiliated_team = affiliated_team;
      // 標準でセレクトされる年を設定
      if (this.affiliated_team == "giants") {
        this.selected = "1993";
      } else {
        this.selected = "2003";
      }
    }
  }
});
// export default class Page extends Vue {}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #homerun_info {
    margin-bottom: 0px !important;
    .title {
      margin-bottom: 30px;
    }
    .post {
      width: 90%;
      text-align: right;
      color: #403f3f;
      font-size: 11px;
      margin-bottom: 15px;
      margin-right: 25px;
    }
    #table_field {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      flex-wrap: wrap;
      #select_column {
        display: flex;
        width: 90%;
        justify-content: flex-end;
        margin-bottom: 5px;
        #button_area {
          display: flex;
          width: 200px;
          // margin-right: 30%;
          .button {
            font-size: 13px;
            width: 60px;
            margin: 0px 5px;
          }
        }
        .select {
          margin: right;
          width: 200px;
        }
      }
      .tb {
        overflow-x: scroll;
        width: 90%;
        table {
          // width: 90%;
          width: 1100px;
          font-size: 16px;
          text-align: center;
          border-collapse: collapse;
          tr:first-child {
            border-bottom: 1px solid #403f3f;
          }
          th,
          td {
            padding: 11px 2px;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 1024px) {
  #homerun_info {
    .title {
      margin-bottom: 30px;
      text-align: center;
    }
    .post {
      width: 800px;
      text-align: right;
      color: #403f3f;
      font-size: 14px;
      margin-bottom: 15px;
      margin-right: 50px;
    }
    #table_field {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      flex-wrap: wrap;
      #select_column {
        display: flex;
        width: 800px;
        justify-content: flex-end;
        margin-bottom: 5px;
        #button_area {
          display: flex;
          width: 200px;
          margin-right: 400px;
          .button {
            width: 80px;
            margin: 0px 10px;
          }
        }
        .select {
          margin: right;
          width: 200px;
        }
      }
      table {
        width: 900px;
        font-size: 13px;
        text-align: center;
        border-collapse: collapse;
        tr:first-child {
          border-bottom: 1px solid #403f3f;
        }
        th,
        td {
          padding: 11px 0px;
        }
      }
    }
  }
}
</style>
